import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-sort",
  "use": "foquz-icon-sort-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol viewBox=\"0 0 8 5\" fill=\"none\" id=\"foquz-icon-sort\"><path d=\"M.96.25c-.515 0-.772.61-.397.96L3.352 4c.21.234.562.234.796 0l2.79-2.79c.351-.35.093-.96-.399-.96H.961z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol